import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

const AuthService = () => {
  const API_URL = "http://localhost/territorio/territorio-main/backend/public";

  const API_WEB_URL = "https://roanprojects.000webhostapp.com";
  const navigate = useNavigate();

  const login = async (username, password) => {
    try {
      const res = await axios.post(
        `/login`,

        {
          username,
          password,
        }
      );
      let data = JSON.parse(res.data);
      console.log(data);

      if (data.token) {
        localStorage.setItem("site", JSON.stringify(data.token));
        navigate("/dashboard");
      }
      return data;
    } catch (error) {
      console.error("Error during login:", error);
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem("site");
    navigate("/login");
  };

  const getCurrentUser = () => {
    const TESTING = false;
    const token = localStorage.getItem("site");
    if (!TESTING) {
      if (token) {
        const decodedToken = jwtDecode(token);
        return decodedToken.sub;
      } else {
        return null;
      }
    } else {
      return "tester";
    }
  };

  const getCurrentToken = () => {
    return JSON.parse(localStorage.getItem("site"));
  };

  return {
    login,
    logout,
    getCurrentUser,
    getCurrentToken,
  };
};

export default AuthService;
